import React from 'react';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faCircle, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';

import { Table, Column, Button } from '@smartplatform/ui';
import getPagesTree from './getPagesTree';
import store from '../../store';

@observer
export default class List extends React.Component {

	@observable records = null;
	@observable navTypes = {};
	
	constructor(props) {
		super(props);
		console.log('Tree');
		this.isAdmin = store.model.roles ? store.model.roles.findIndex(role => role.name === 'admin') !== -1 : false;
		this.init();
	}
	
	init = async () => {
		const { tree } = await getPagesTree(this.props.parentId || null);
		const pageNav = await store.model.PageNav.find();
		const navTypes = {};
		pageNav.forEach(navType => navTypes[navType.id] = navType.name);
		this.navTypes = navTypes;
		console.log('tree', tree);
		this.records = tree;
	};
	
	toggle = id => {
		console.log('toggle', id);
		const li = document.getElementById('page-' + id);
		console.log('li', li);
		li.classList.toggle('active');
	};
	
	@action orderUp = async record => {
		const res = await store.model.Page.find({
			where: {
				parentId: record.parentId,
				order: { lt: record.order },
			},
			fields: ['id', 'order'],
			order: 'order desc',
		});
		const prev = res.length > 0 ? res[0] : null;
		if (prev) {
			if (!record.order) record.order = record.id;
			if (!prev.order) prev.order = prev.id;
			console.log('orderUp', record.order, prev.order);
			const prevOrder = prev.order;
			prev.order = record.order;
			record.order = prevOrder;
			prev.text = undefined;
			record.text = undefined;
			await record.save();
			await prev.save();
			await this.init();
		}
		else {
			console.warn('previous not found');
		}
	};
	
	@action orderDown = async record => {
		const res = await store.model.Page.find({
			where: {
				parentId: record.parentId,
				order: { gt: record.order },
			},
			order: 'order asc',
		});
		const next = res.length > 0 ? res[0] : null;
		if (next) {
			if (!record.order) record.order = record.id;
			if (!next.order) next.order = next.id;
			console.log('orderDown', record.order, next.order);
			const prevOrder = next.order;
			next.order = record.order;
			record.order = prevOrder;
			next.text = undefined;
			record.text = undefined;
			await record.save();
			await next.save();
			await this.init();
		}
		else {
			console.warn('next not found');
		}
	};
	
	renderPageItem = (record) => {
		const active = store.local.expandPages || (this.props.parentId && store.local.expandPagesInside);
		return <li key={record.id} id={'page-' + record.id} className={active ? 'active' : ''}>
			<div className="page-item">
				<div className="expand">
					{record.__children.length > 0 ?
						<FontAwesomeIcon icon={faChevronRight} className="arrow" onClick={() => this.toggle(record.id)} />
						:
						<FontAwesomeIcon icon={faCircle} className="disc" />
					}
				</div>
				<div className="title">
					<Link to={`/admin/static/${record.id}`}>{record.title}</Link>
					<span className="id">[id: {record.id}]</span>
					{record.navId ? <span className="nav">[{this.navTypes[record.navId]}]</span> : null}
				</div>
				<span className="route">{record.route}</span>
				{this.props.parentId && <span className="order">
					<FontAwesomeIcon className="order-up" icon={faChevronUp} onClick={() => this.orderUp(record)} />
					<FontAwesomeIcon className="order-down" icon={faChevronDown} onClick={() => this.orderDown(record)} />
				</span>}
			</div>
			<ul>{record.__children.map(this.renderPageItem)}</ul>
		</li>;
	};
	
	render() {
		if (!this.records) return '...';
		
		return <ul className="pages-hierarchy">{this.records.map(this.renderPageItem)}</ul>;
	}
	
}
